import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../navigation/header/headerSlice';
import { useEffect } from 'react';

import { Contacts } from './contacts';
import { Schedule } from './schedule';

import {ReactComponent as ShopIcon} from "../../assets/images/icons/shop.svg";
import {ReactComponent as ScheduleIcon} from "../../assets/images/icons/schedule.svg";
import {ReactComponent as CrossIcon} from "../../assets/images/icons/cross_second.svg";

import './about.css';

export const About = () => {
    const dispatch = useDispatch();
    const showAbout = useSelector(state => state.header.aboutActive);
    const aboutData = useSelector(state => state.header?.about || {});
    const {about, companyName,  ...rest} = aboutData;
    const schedule = useSelector(state => state.header.schedule);

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;  
        document.body.style.overflow = 'hidden';
        return () => document.body.style.overflow = originalStyle;
    }, []);

    return (
        <div className="modal" style={{display: 'block'}}>
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">
                            {companyName && companyName}
                        </h1>
                        <button type="button" className="btn-close" onClick={() => dispatch(showModal(showAbout))}></button>
                    </div>
                    <div className="modal-body">
                        {about &&
                            <div className="row">
                                <div className="col border-bottom mt-3">
                                    <div className="d-flex align-items-center">
                                        <ShopIcon/>
                                        <p className="h3 m-0 ms-2">Про нас</p>
                                    </div>
                                    <p className="fs-5 ms-3">{about}</p>
                                </div>
                            </div>
                        }
                        {Object.keys(rest).length !== 0 &&
                            <div className="row">
                                <div className="col border-bottom mt-3">
                                    <Contacts rest={rest}/>
                                </div>
                            </div>
                        }
                        {schedule && schedule.length !== 0 &&
                            <div className="row">
                                <div className="col border-bottom mt-3">
                                    <div className="d-flex align-items-center">
                                        <ScheduleIcon/>
                                        <p className="h3 m-0 ms-2">Графік роботи</p>
                                    </div>
                                    <Schedule rest={schedule}/>
                                </div>
                            </div>
                        }
                         <div className="row">
                            <div className="col text-center mt-3">
                                <a className="text-decoration-none" target="_blank" href={`${window.location.origin}/menu/oferta.php`}>Договір публічної оферти</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
